import { fi } from 'date-fns/locale'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)



export default new Vuex.Store({
  state: {
    apiKey: undefined,
    jwt: undefined,
    loggedIn: false,
    allowContentSwitch: true,
    validMpLicense: false,
    validMzLicense: false,
    validAsLicense: false,
    validStatsLicense: false,
    imgCacheTimestamp: Date.now(),
    storeId: localStorage.getItem("selected_store"),
    storeData: {},
    companyId: localStorage.getItem("selected_company"),
    businessunits: [],
    rosterFromTo: undefined,
    accountPreference: JSON.parse(localStorage.getItem("accountPreference")),
    permissions: {},
    userInfo: {},
    isSuperUser: false,
    isOwner: false,
    storeSettings: {},
    businessUnitMap: {},
    businessUnitMapState: {},
    skillMap: {},
    skillMapState: {},
    spotMap: {},
    spotMapState: {},
    employeeMap: {},
    employeeMapState: {},
    employeeMissingExternalIdMap: {},
    employeeMissingExternalIdMapState: {},
    employeeTypeMapState: {},
    employeeTypeMap: {},
    employeeWeeklyParametersMapState: {},
    employeeWeeklyParametersMap: {},
    employeeTypeTemplateMapState: {},
    employeeTypeTemplateMap: {},
    employeeExtraPaymentMap: {},
    employeeExtraPaymentMapState: {},
    employmentModelMap: {},
    employmentModelMapState: {},
    employeeEmploymentModelMap: {},
    employeeEmploymentModelMapState: {},
    actualShiftMapState: {},
    actualShiftMap: {},
    actualBreakMapState: {},
    actualBreakMap: {},
    actualShiftMaxState: {},
    actualShiftMax: 0,
    planShiftMapState: {},
    planShiftMap: {},
    externalShiftMapState: {},
    externalShiftMap: {},
    shiftTimeByDayMapState: {},
    shiftTimeByDayMap: {},
    shiftTimeByHourMapState: {},
    shiftTimeByHourMap: {},
    shiftTemplateMapState: {},
    shiftTemplateMap: {},
    shiftTemplateGroupMapState: {},
    shiftTemplateGroupMap: {},
    shiftTemplateGroupFrameMapState: {},
    shiftTemplateGroupFrameMap: {},
    employeeRulesTemplateMapState: {},
    employeeRulesTemplateMap: {},
    employeeRulesMap: {},
    employeeRulesMapState: {},
    collectiveContractMap: {},
    collectiveContractMapState: {},
    mlCollectiveAgreementMap: {},
    mlCollectiveAgreementMapState: {},
    mlCostCenterMap: {},
    mlCostCenterMapState: {},
    youthWorkConfigMap: {},
    youthWorkConfigMapState: {},
    allowedContractMap: {},
    allowedContractMapState: {},
    employeeContractMap: {},
    employeeContractMapState: {},
    currentMonthEmployeeContractMap: {},
    currentMonthEmployeeContractMapState: {},
    employeePreferenceMap: {},
    employeePreferenceMapState: {},
    employeeAllUnapprovedPreferenceMap: {},
    employeeAllUnapprovedPreferenceMapState: {},
    employeeSkillMap: {},
    employeeSkillMapState: {},
    employeeAvailabilityMap: {},
    employeeAvailabilityMapState: {},
    employeeWorkbalanceMap: {},
    employeeWorkbalanceMapState: {},
    employeeFilesMap: {},
    employeeFilesMapState: {},
    eventLogMap: {},
    eventLogMapState: {},

    rosterBackupMap: {},
    rosterBackupMapState: {},

    shiftSkillMap: {},
    shiftSkillMapState: {},

    userUnitSortMapState: {},
    userUnitSortMap: {},

    uiDataMap: {},
    uiDataMapState: {},

    holidayMapState: {},
    holidayMap: {},
    activeStoreUsersMap: {},

    externalServicesMap: {},
    externalServicesMapState: {},
    apiIntegrationDataMap: {},
    apiIntegrationDataState: {},
    projectMap: {},
    projectMapState: {},
    projectGroupMap: {},
    projectGroupMapState: {},
    locationMap: {},
    locationMapState: {},
    exportSettingsMap: {},
    exportSettingsMapState: {},
    employeeExternalDataMap: {},
    accountingPeriodSettingsMap: {},
    accountingPeriodSettingsMapState: {},
    contractExitSettingMap: {},
    contractExitSettingState: {},
    bonusPaymentSettingsMap: {},
    bonusPaymentSettingsMapState: {},
    crewlaborPlanningMap: {},
    crewlaborPlanningMapState: {},
    planningEmployeeMap: {},
    planningEmployeeMapState: {},
    planningIndicatorTypeMap: {},
    planningIndicatorTypeMapState: {},
    planningEmployeeThresholdMap: {},
    planningEmployeeThresholdMapState: {},
    contactPersonMap: {},
    contactPersonMapState: {},
    emailNotificationMap: {},
    emailNotificationMapState: {},
    mlEmailNotificationMap: {},
    mlEmailNotificationMapState: {},
    externalApiAccessMap: {},
    externalApiAccessMapState: {},
    storeOpeningHoursMap: {},
    storeOpeningHoursMapState: {},
    shiftStatusLogMap: {},
    shiftStatusLogMapState: {},
    vlhTimeFrameMap: {},
    vlhTimeFrameMapState: {},
    vlhConversionMap: {},
    vlhConversionMapState: {},
    vlhConfigMap: {},
    vlhConfigMapState: {},
    vlhEmployeeThresholdMap: {},
    vlhEmployeeThresholdMapState: {},
    employeeAvgWorktimeMap: {},
    employeeAvgWorktimeMapState: {},
    fixedCostMap: {},
    fixedCostMapState: {},
    rosterNoticeMap: {},
    rosterNoticeMapState: {},
    positioningTaskMap: {},
    positioningTaskMapState: {},
    positioningTaskAssignmentMap: {},
    positioningTaskAssignmentMapState: {},
    positioningEntryMap: {},
    positioningEntryMapState: {},

    nightMode: false,
    anonMode: false,
    rosterVisibilityState: {
      visibilityKVErrors: true,
      visibilityPlanErrors: true,
      visibilityShiftStatusErrors: true,
      calculatePastPlanning: false,
      visibilityOverlappingErrors: true,
      visibilityActualShifts: true,
      visibilityPlanShifts: true,
      visibilityUndesired: true,
      visibilityDesired: true,
      visibilityNotAvailable: true,
      visibilityOnlyAvailable: true,
      visibilityVacation: true,
      visibilitySick: true,
      visibilityHolidayAdjustment: true,
      visibilityEducation: true,
      visibilityWageContinuation: true,
      daySpotColorSwitch: false,
      dayHourlyValuesWithPauseSwitch: true,
      dayProjectColorSwitch: false,
      visibilityProductivity: false,
      visibilityProductivityNew: false,
      visibilityRoundProductivity: false,
      rosterDailyShiftTimeSort: true,
      visibilityProductivityIncludeMgmt: true,
      addHolidayTimeToWorkTime: false,
      visibilityMonthOnly: true,
      visibilityKeyFigures: false,
    },
    rosterSortState: {
      showBusinessUnits: false,
      showSpots: true,
      showShiftSpots: false,
      filterByShiftSpot: false,
      filterByOnlyShiftSpot: false,
      showSpotPlanningNumbersSwitch: false,
    },
    notificationBellConfigState: {
      showExpiredDocuments: true,
      showExpiringDocuments: true,
      documentExpiryLimit: 56,
      showUnapprovedPreferences: true,
      showDeclinedShifts: true,
      showExpiringContracts: true,
      contractExpiryLimit: 56,
      showMissingExternalIds: true,
      showUnpublishedShifts: true,
      showUnconfirmedWorkbalance: true,
      showMissingDataForUnderagedEmployees: true,
      showMissingAvailabilityEmployees: true,
      showMissingContractDocuments: true,
      showUnconfirmedDocuments: true,
      showMissingPassDocumentsForNonEU: true,
      showMissingWorkPermitDocumentsForNonEU: true,
      showMissingResidencePermitDocumentsForNonEU: true,
      showMissingEducationPermitDocumentsForNonEU: true,
      showMissingPersonnelIds: true,
    },
    employeeSortState: {
      showBusinessUnits: true,
      sortByContractType: false,
      sortByPriority: true
    },
    ftaConfigState: {
      configSelectionTimeframe: 0,
      configCreateTimeframe: 0,
      configUseOvertime: true,
      configUseWeekOvertime: true,
      configUseCustomMax: false,
      configAllowOverPlanWorktime: false,
      configAddPositivePrevMonthWorktime: true,
      configAddNegativePrevMonthWorktime: false,
      configAllowDaysWithPastMidnight: false,
      customMaxTime: 9.0,
      additionalFTADays: 0,
      maxWorkDays: 5,
    },
    crewLaborConfig: {
        holidayWorkValue: true,
        workValue: true,
        openWorkValue: false,
        nightWorkShiftFlatValue: true,
        nightWorkValue: true,
        overtimeShiftFlatValue: true,
        overtimeValue: true,
        vacationWorkValue: true,
        sickWorkValue: true,
        holidayAdjustWorkValue: false,
        miscWorkValue: true,
        nursingVacationWorkValue: true,
        eduWorkValue: true,
        wageContinuationWorkValue: true,
    },
    crewLaborConfigState: {},
    sotecWebcockpitConfig: null,
    sotecWebcockpitConfigState: {},
    rosterView: true,
    selectableStores: [],

    // PersonnelDeployment
    displayPdChart: localStorage.getItem('rosterdisplayPdChart') === '1',
    pdCachedData: {},
    pdDetailData: null,
    pdPastDetailData: null,
    pdSelectedStat: null,
    pdChartAreaHeight: null,
  },
  getters: {
    rosterView: state => {
      return state.rosterView
    },
    jwt: state => {
      return state.jwt;
    },
    loggedIn: state => {
      return state.loggedIn;
    },
    allowContentSwitch: state => {
      return state.allowContentSwitch;
    },
    storeId: state => {
      return state.storeId;
    },
    selectableStores: state => {
      return state.selectableStores;
    },
    storeData: state => {
      return state.storeData
    },
    validMpLicense: state => {
      return state.validMpLicense;
    },
    validMzLicense: state => {
      return state.validMzLicense;
    },
    validAsLicense: state => {
      return state.validAsLicense;
    },
    validStatsLicense: state => {
      return state.validStatsLicense;
    },
    imgCacheTimestamp: state => {
      return state.imgCacheTimestamp;
    },
    rosterFromTo: state => {
      if (state.rosterFromTo) {
        return state.rosterFromTo;
      } else {
        return null;
      }
    },
    rosterFromToKey: state => {
      if (state.rosterFromTo && state.rosterFromTo.from && state.rosterFromTo.to) {
        return state.rosterFromTo.from + " - " + state.rosterFromTo.to;
      } else {
        return "no-key"
      }
    },
    userInfo: state => {
      return state.userInfo;
    },
    accountPreference: state => {
      return state.accountPreference;
    },
    permissions: state => {
      return state.permissions;
    },
    storeSettings: state => {
      return state.storeSettings;
    },
    isSuperUser: state => {
      return state.isSuperUser;
    },
    isOwner: state => {
      return state.isOwner;
    },
    activeStoreUsersMap: state => {
      if (state.activeStoreUsersMap) {
        let map = state.activeStoreUsersMap;
        if (!state.isSuperUser) {
          let filter = ["91bce5c8-6172-43bb-8e6a-721032659d94", "801395ab-001f-42a2-9fb9-dd879323cbba", "13cd4232-d4a9-4632-b169-561bcba58cf6", "d7789f86-fdad-4491-b7f2-75cedfff8858", "1521fa5a-ef75-4aca-93f5-fa912e9f0f6d"];
          Object.values(map).filter(u => filter.find(sid => u.id === sid)).forEach(u => u.hidden = true);
        }
        return map;
      } else {
        return {};
      }
    },
    businessUnitMap: state => {
      return state.businessUnitMap ? state.businessUnitMap : {}
    },
    businessUnitArray: state => {
      return state.businessUnitMap ? Object.values(state.businessUnitMap) : []
    },
    businessUnitById: state => id => {
      if (state.businessUnitMap) {
        return state.businessUnitMap[id];
      } else {
        return null;
      }
    },
    skillMap: state => {
      return state.skillMap ? state.skillMap : {}
    },
    skillArray: state => {
      return state.skillMap ? Object.values(state.skillMap) : []
    },
    skillById: state => id => {
      if (state.skillMap) {
        return state.skillMap[id];
      } else {
        return null;
      }
    },
    spotMap: state => {
      return state.spotMap ? state.spotMap : {}
    },
    spotArray: state => {
      return state.spotMap ? Object.values(state.spotMap) : []
    },
    spotById: state => id => {
      if (state.spotMap) {
        return state.spotMap[id];
      } else {
        return null;
      }
    },
    employeeMap: state => {
      return state.employeeMap ? state.employeeMap : {}
    },
    employeeArray: state => {
      return state.employeeMap ? Object.values(state.employeeMap) : []
    },
    employeeById: state => id => {
      if (state.employeeMap) {
        return state.employeeMap[id];
      } else {
        return null;
      }
    },
    employeeMissingExternalIdMap: state => {
      return state.employeeMissingExternalIdMap ? state.employeeMissingExternalIdMap : {}
    },
    employeeMissingExternalIdMapArray: state => {
      return state.employeeMissingExternalIdMap ? Object.values(state.employeeMissingExternalIdMap) : []
    },
    shiftTemplateMap: state => {
      return state.shiftTemplateMap ? state.shiftTemplateMap : {}
    },
    shiftTemplateArray: state => {
      return state.shiftTemplateMap ? Object.values(state.shiftTemplateMap) : []
    },
    shiftTemplateGroupMap: state => {
      return state.shiftTemplateGroupMap ? state.shiftTemplateGroupMap : {}
    },
    shiftTemplateGroupArray: state => {
      return state.shiftTemplateGroupMap ? Object.values(state.shiftTemplateGroupMap) : []
    },
    shiftTemplateGroupFrameMap: state => {
      return state.shiftTemplateGroupFrameMap ? state.shiftTemplateGroupFrameMap : {}
    },
    shiftTemplateGroupFrameArray: state => {
      return state.shiftTemplateGroupFrameMap ? Object.values(state.shiftTemplateGroupFrameMap) : []
    },
    planShiftMap: state => {
      return state.planShiftMap ? state.planShiftMap : {}
    },
    planShiftArray: state => {
      return state.planShiftMap ? Object.values(state.planShiftMap) : []
    },
    externalShiftMap: state => {
      return state.externalShiftMap ? state.externalShiftMap : {}
    },
    externalShiftArray: state => {
      return state.externalShiftMap ? Object.values(state.externalShiftMap) : []
    },
    planShiftById: state => id => {
      if (state.planShiftMap) {
        return state.planShiftMap[id];
      } else {
        return null;
      }
    },
    shiftTimeByDayMap: state => {
      return state.shiftTimeByDayMap ? state.shiftTimeByDayMap : {}
    },
    shiftTimeByHourMap: state => {
      return state.shiftTimeByHourMap ? state.shiftTimeByHourMap : {}
    },
    employeeRulesTemplateMap: state => {
      return state.employeeRulesTemplateMap ? state.employeeRulesTemplateMap : {};
    },
    employeeRulesTemplateArray: state => {
      return state.employeeRulesTemplateMap ? Object.values(state.employeeRulesTemplateMap) : [];
    },
    employeeRulesMap: state => {
      return state.employeeRulesMap ? state.employeeRulesMap : {};
    },
    employeeRulesArray: state => {
      return state.employeeRulesMap ? Object.values(state.employeeRulesMap) : [];
    },
    employeeTypeMap: state => {
      return state.employeeTypeMap ? state.employeeTypeMap : {}
    },
    employeeTypeArray: state => {
      return state.employeeTypeMap ? Object.values(state.employeeTypeMap) : []
    },
    employeeFilesMap: state => {
      return state.employeeFilesMap ? state.employeeFilesMap : {};
    },
    employeeFilesArray: state => {
      return state.employeeFilesMap ? Object.values(state.employeeFilesMap) : [];
    },
    employeeWeeklyParametersMap: state => {
      return state.employeeWeeklyParametersMap ? state.employeeWeeklyParametersMap : {}
    },
    employeeWeeklyParametersArray: state => {
      return state.employeeWeeklyParametersMap ? Object.values(state.employeeWeeklyParametersMap) : []
    },
    employeeWeeklyParametersMapState: state => {
      return state.employeeWeeklyParametersMapState ? state.employeeWeeklyParametersMapState : {}
    },
    employmentModelMap: state => {
      return state.employmentModelMap ? state.employmentModelMap : {}
    },
    employeeEmploymentModelMap: state => {
      return state.employeeEmploymentModelMap ? state.employeeEmploymentModelMap : {}
    },
    employeeTypeById: state => id => {
      if (state.employeeTypeMap) {
        return state.employeeTypeMap[id];
      } else {
        return null;
      }
    },
    employeeRulesById: state => id => {
      if (state.employeeRulesMap) {
        return state.employeeRulesMap[id];
      } else {
        return null;
      }
    },
    employeeTypeTemplateMap: state => {
      return state.employeeTypeTemplateMap ? state.employeeTypeTemplateMap : {}
    },
    employeeTypeTemplateArray: state => {
      return state.employeeTypeTemplateMap ? Object.values(state.employeeTypeTemplateMap) : []
    },
    employeeTypeTemplateById: state => id => {
      if (state.employeeTypeTemplateMap) {
        return state.employeeTypeTemplateMap[id];
      } else {
        return null;
      }
    },
    employeeRulesTemplateById: state => id => {
      if (state.employeeRulesTemplateMap) {
        return state.employeeRulesTemplateMap[id];
      } else {
        return null;
      }
    },
    actualShiftMap: state => {
      return state.actualShiftMap ? state.actualShiftMap : {}
    },
    actualShiftArray: state => {
      return state.actualShiftMap ? Object.values(state.actualShiftMap) : []
    },
    actualShiftById: state => id => {
      if (state.actualShiftMap) {
        return state.actualShiftMap[id];
      } else {
        return null;
      }
    },
    actualBreakMap: state => {
      return state.actualBreakMap ? state.actualBreakMap : {}
    },
    actualBreakArray: state => {
      return state.actualBreakMap ? Object.values(state.actualBreakMap) : []
    },
    actualBreakById: state => id => {
      if (state.actualBreakMap) {
        return state.actualBreakMap[id];
      } else {
        return null;
      }
    },
    actualShiftMax: state => {
      return state.actualShiftMax ? state.actualShiftMax : 0
    },
    userUnitSortMap: state => {
      return state.userUnitSortMap ? state.userUnitSortMap : {}
    },
    holidayMap: state => {
      return state.holidayMap ? state.holidayMap : {}
    },
    collectiveContractMap: state => {
      return state.collectiveContractMap ? state.collectiveContractMap : {};
    },
    collectiveContractArray: state => {
      return state.collectiveContractMap ? Object.values(state.collectiveContractMap) : [];
    },
    mlCollectiveAgreementMap: state => {
      return state.mlCollectiveAgreementMap ? state.mlCollectiveAgreementMap : {};
    },
    mlCostCenterMap: state => {
      return state.mlCostCenterMap ? state.mlCostCenterMap : {};
    },
    youthWorkConfigMap: state => {
      return state.youthWorkConfigMap ? state.youthWorkConfigMap : {};
    },
    youthWorkConfigArray: state => {
      return state.youthWorkConfigMap ? Object.values(state.youthWorkConfigMap) : [];
    },
    allowedContractMap: state => {
      return state.allowedContractMap ? state.allowedContractMap : {};
    },
    accountingPeriodSettingsMap: state => {
      return state.accountingPeriodSettingsMap ? state.accountingPeriodSettingsMap : {};
    },
    contractExitSettingMap: state => {
      return state.contractExitSettingMap ? state.contractExitSettingMap : {};
    },
    bonusPaymentSettingsMap: state => {
      return state.bonusPaymentSettingsMap ? state.bonusPaymentSettingsMap : {};
    },
    allowedContractArray: state => {
      return state.allowedContractMap ? Object.values(state.allowedContractMap) : [];
    },
    shiftSkillMap: state => {
      return state.shiftSkillMap ? state.shiftSkillMap : {};
    },
    shiftSkillArray: state => {
      return state.shiftSkillMap ? Object.values(state.shiftSkillMap) : [];
    },
    employeeContractMap: state => {
      return state.employeeContractMap ? state.employeeContractMap : {};
    },
    employeeContractArray: state => {
      return state.employeeContractMap ? Object.values(state.employeeContractMap) : [];
    },
    employeeExtraPaymentMap: state => {
      return state.employeeExtraPaymentMap ? state.employeeExtraPaymentMap : {};
    },
    employeeExtraPaymentArray: state => {
      return state.employeeExtraPaymentMap ? Object.values(state.employeeExtraPaymentMap) : [];
    },
    currentMonthEmployeeContractMap: state => {
      return state.currentMonthEmployeeContractMap ? state.currentMonthEmployeeContractMap : {};
    },
    currentMonthEmployeeContractArray: state => {
      return state.currentMonthEmployeeContractMap ? Object.values(state.currentMonthEmployeeContractMap) : [];
    },
    employeePreferenceMap: state => {
      return state.employeePreferenceMap ? state.employeePreferenceMap : {};
    },
    employeePreferenceArray: state => {
      return state.employeePreferenceMap ? Object.values(state.employeePreferenceMap) : [];
    },
    employeeAllUnapprovedPreferenceMap: state => {
      return state.employeeAllUnapprovedPreferenceMap ? state.employeeAllUnapprovedPreferenceMap : {};
    },
    employeeAllUnapprovedPreferenceArray: state => {
      return state.employeeAllUnapprovedPreferenceMap ? Object.values(state.employeeAllUnapprovedPreferenceMap) : [];
    },
    employeeSkillMap: state => {
      return state.employeeSkillMap ? state.employeeSkillMap : {};
    },
    employeeSkillArray: state => {
      return state.employeeSkillMap ? Object.values(state.employeeSkillMap) : [];
    },
    employeeWorkbalanceMap: state => {
      return state.employeeWorkbalanceMap ? state.employeeWorkbalanceMap : {};
    },
    employeeWorkbalanceArray: state => {
      return state.employeeWorkbalanceMap ? Object.values(state.employeeWorkbalanceMap) : [];
    },
    employeeAvailabilityMap: state => {
      return state.employeeAvailabilityMap ? state.employeeAvailabilityMap : {};
    },
    employeeAvailabilityArray: state => {
      return state.employeeAvailabilityMap ? Object.values(state.employeeAvailabilityMap) : [];
    },
    eventLogMap: state => {
      return state.eventLogMap ? state.eventLogMap : {};
    },
    eventLogArray: state => {
      return state.eventLogMap ? Object.values(state.eventLogMap) : [];
    },
    uiDataMap: state => {
      return state.uiDataMap ? state.uiDataMap : {};
    },
    externalServicesMap: state => {
      return state.externalServicesMap ? state.externalServicesMap : {};
    },
    externalServicesArray: state => {
      return state.externalServicesMap ? Object.values(state.externalServicesMap) : [];
    },
    apiIntegrationDataMap: state => {
      return state.apiIntegrationDataMap ? state.apiIntegrationDataMap : {};
    },
    apiIntegrationDataArray: state => {
      return state.apiIntegrationDataMap ? Object.values(state.apiIntegrationDataMap) : [];
    },
    projectMap: state => {
      return state.projectMap ? state.projectMap : {};
    },
    projectArray: state => {
      return state.projectMap ? Object.values(state.projectMap) : [];
    },
    projectGroupMap: state => {
      return state.projectGroupMap ? state.projectGroupMap : {};
    },
    projectGroupArray: state => {
      return state.projectGroupMap ? Object.values(state.projectGroupMap) : [];
    },
    locationMap: state => {
      return state.locationMap ? state.locationMap : {};
    },
    locationArray: state => {
      return state.locationMap ? Object.values(state.locationMap) : [];
    },
    exportSettingsMap: state => {
      return state.exportSettingsMap ? state.exportSettingsMap : {};
    },
    employeeExternalDataMap: state => {
      return state.employeeExternalDataMap ? state.employeeExternalDataMap : {};
    },
    employeeExternalDataArray: state => {
      return state.employeeExternalDataMap ? Object.values(state.employeeExternalDataMap) : [];
    },
    crewlaborPlanningMap: state => {
      return state.crewlaborPlanningMap ? state.crewlaborPlanningMap : {};
    },
    planningEmployeeMap: state => {
      return state.planningEmployeeMap ? state.planningEmployeeMap : {};
    },
    planningEmployeeThresholdMap: state => {
      return state.planningEmployeeThresholdMap ? state.planningEmployeeThresholdMap : {};
    },
    contactPersonMap: state => {
      return state.contactPersonMap ? state.contactPersonMap : {};
    },
    emailNotificationMap: state => {
      return state.emailNotificationMap ? state.emailNotificationMap : {};
    },
    mlEmailNotificationMap: state => {
      return state.mlEmailNotificationMap ? state.mlEmailNotificationMap : {};
    },
    externalApiAccessMap: state => {
      return state.externalApiAccessMap ? state.externalApiAccessMap : {};
    },
    storeOpeningHoursMap: state => {
      return state.storeOpeningHoursMap ? state.storeOpeningHoursMap : {};
    },
    shiftStatusLogMap: state => {
      return state.shiftStatusLogMap ? state.shiftStatusLogMap : {};
    },
    vlhTimeFrameMap: state => {
      return state.vlhTimeFrameMap ? state.vlhTimeFrameMap : {};
    },
    vlhConversionMap: state => {
      return state.vlhConversionMap ? state.vlhConversionMap : {};
    },
    vlhConfigMap: state => {
      return state.vlhConfigMap ? state.vlhConfigMap : {};
    },
    vlhEmployeeThresholdMap: state => {
      return state.vlhEmployeeThresholdMap ? state.vlhEmployeeThresholdMap : {};
    },
    employeeAvgWorktimeMap: state => {
      return state.employeeAvgWorktimeMap ? state.employeeAvgWorktimeMap : {};
    },
    planningIndicatorTypeMap: state => {
      return state.planningIndicatorTypeMap ? state.planningIndicatorTypeMap : {};
    },
    fixedCostMap: state => {
      return state.fixedCostMap ? state.fixedCostMap : {};
    },
    nightMode: state => {
      return state.nightMode;
    },
    anonMode: state => {
      return state.anonMode;
    },
    rosterBackupMap: state => {
      return state.rosterBackupMap ? state.rosterBackupMap : {};
    },
    rosterNoticeMap: state => {
      return state.rosterNoticeMap ? state.rosterNoticeMap : {};
    },
    positioningTaskMap: state => {
      return state.positioningTaskMap ? state.positioningTaskMap : {};
    },
    positioningTaskAssignmentMap: state => {
      return state.positioningTaskAssignmentMap ? state.positioningTaskAssignmentMap : {};
    },
    positioningEntryMap: state => {
      return state.positioningEntryMap ? state.positioningEntryMap : {};
    },
    employeeSortState: state => {
      return state.employeeSortState;
    },
    rosterSortState: state => {
      return state.rosterSortState;
    },
    rosterVisibilityState: state => {
      return state.rosterVisibilityState;
    },
    notificationBellConfigState: state => {
      return state.notificationBellConfigState;
    },
    ftaConfigState: state => {

      return state.ftaConfigState;
    },
    crewLaborConfig: state => {
      return state.crewLaborConfig;
    },
    crewLaborConfigState: state => {
      return state.crewLaborConfigState ? state.crewLaborConfigState : {}
    },
    sotecWebcockpitConfig: state => {
      return state.sotecWebcockpitConfig
    },
    sotecWebcockpitConfigState: state => {
      return state.sotecWebcockpitConfigState ? state.sotecWebcockpitConfigState : {}
    },
    displayPdChart: state => {
      return state.displayPdChart;
    },
    renderPdChart: state => {
      let companyIds = [11, 13, 14, 31, 133, 158, 214] //158 is hettich
      let validCompany = state.storeSettings != null && (companyIds.includes(state.storeSettings.companyId));

      let accountIds = ['3572b5c2-2cbc-417b-9134-133f216b05d4']
      let validUser = state.userInfo != null && accountIds.includes(state.userInfo.id);

      if(state.isSuperUser){
        return true;
      } else if(validCompany || validUser) {
        let perm = false;
        Object.values(state.permissions).forEach(perms => {
          if(perms.map(perm => perm.id).includes(79)) { //permission to read statistics
            perm = true;
          }
        })
        return  perm ;
      } else if(state.validStatsLicense && state.isOwner){
        let perm = false;
        Object.values(state.permissions).forEach(perms => {
          if(perms.map(perm => perm.id).includes(79)) { //permission to read statistics
            perm = true;
          }
        })
        return  perm ;
      } else {
        return false;
      }

    },
    pdCachedData: state => {
      return state.pdCachedData;
    },
    pdDataMaps: (state) => (cachingKey) => {
      let data = state.pdCachedData[cachingKey];
      return data ? data.data : null;
    },
    pdDetailData: state => {
      return state.pdDetailData;
    },
    pdPastDetailData: state => {
      return state.pdPastDetailData;
    },
    pdSelectedStat: state => {
      return state.pdSelectedStat;
    },
    pdChartAreaHeight: state => {
      return state.pdChartAreaHeight;
    },
  },
  mutations: {
    setRosterView: function (state, payload) {
      state.rosterView = payload.rosterView;
    },
    setImgCacheTimestamp: function (state, payload) {
      state.imgCacheTimestamp = payload.imgCacheTimestamp;
    },
    setUserInfo: function (state, payload) {
      state.userInfo = payload.userInfo;
    },
    setApiKey: function (state, payload) {
      state.apiKey = payload.apiKey;
    },
    setStoreId: function (state, payload) {
      state.storeId = payload.storeId;
      if (payload.storeId != null) {
        localStorage.setItem("selected_store", payload.storeId);
      }

    },
    setStoreData: function (state, payload) {
      state.storeData = payload.storeData;
    },
    setSelectableStores: function (state, payload) {
      state.selectableStores = payload.selectableStores;
    },
    setCompanyId: function (state, payload) {
      state.companyId = payload.companyId;
      if (payload.companyId != null) {
        localStorage.setItem("selected_company", payload.companyId);
      }

    },
    setJWT: function (state, payload) {
      state.jwt = payload.jwt;
      //localStorage.setItem("md_token", payload.jwt);
    },
    setLoggedIn: function (state, payload) {
      state.loggedIn = payload.loggedIn;
    },
    setAllowContentSwitch: function (state, payload) {
      state.allowContentSwitch = payload.allowContentSwitch;
    },
    setValidMpLicense: function (state, payload) {
      state.validMpLicense = payload.validMpLicense;
    },
    setValidMzLicense: function (state, payload) {
      state.validMzLicense = payload.validMzLicense;
    },
    setValidAsLicense: function (state, payload) {
      state.validAsLicense = payload.validAsLicense;
    },
    setValidStatsLicense: function (state, payload) {
      state.validStatsLicense = payload.validStatsLicense;
    },
    setIsSuperUser: function (state, payload) {
      state.isSuperUser = payload.isSuperUser;
    },
    setIsOwner: function (state, payload) {
      state.isOwner = payload.isOwner;
    },
    setAccountPreference: function (state, payload) {
      state.accountPreference = payload;
      localStorage.setItem("accountPreference", JSON.stringify(payload));
    },
    clearJWT: function (state) {
      state.jwt = null;
      localStorage.removeItem("md_token");
    },
    setActiveStoreUsersMap: function (state, payload) {

      state.activeStoreUsersMap = Object.assign({}, payload.activeStoreUsersMap);
    },
    setActiveStoreUsersMapEntry: function (state, payload) {
      if (state.activeStoreUsersMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.activeStoreUsersMap = Object.assign({}, state.activeStoreUsersMap, entry);
      }
    },
    deleteActiveStoreUsersMapEntry: function (state, payload) {
      if (state.activeStoreUsersMap) {
        delete state.activeStoreUsersMap[payload.id];
        state.activeStoreUsersMap = Object.assign({}, state.activeStoreUsersMap);
      }
    },
    setRosterFromTo: function (state, payload) {
      //console.log("SETTING ROSTERFROMTO: "+JSON.stringify(payload));
      state.rosterFromTo = Object.assign({}, payload.rosterFromTo);
    },
    setPermissions: function (state, payload) {
      state.permissions = Object.assign({}, payload.permissions);
    },
    setStoreSettings: function (state, payload) {
      state.storeSettings = Object.assign({}, payload.storeSettings);
    },
    setBusinessUnitMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }

      state.businessUnitMapState = tstate;
      state.businessUnitMap = Object.assign({}, payload.businessUnitMap);
    },
    setBusinessUnitMapEntry: function (state, payload) {
      if (state.businessUnitMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.businessUnitMap = Object.assign({}, state.businessUnitMap, entry);
      }
    },
    deleteBusinessUnitMapEntry: function (state, payload) {
      if (state.businessUnitMap) {
        delete state.businessUnitMap[payload.id];
        state.businessUnitMap = Object.assign({}, state.businessUnitMap);
      }
    },
    setSkillMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }
      state.skillMapState = tstate;
      state.skillMap = Object.assign({}, payload.skillMap);
    },
    setSkillMapEntry: function (state, payload) {
      if (state.skillMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.skillMap = Object.assign({}, state.skillMap, entry);
      }
    },
    deleteSkillMapEntry: function (state, payload) {
      if (state.skillMap) {
        delete state.skillMap[payload.id];
        state.skillMap = Object.assign({}, state.skillMap);
      }
    },
    setSpotMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),
      }

      state.spotMapState = tstate;
      state.spotMap = Object.assign({}, payload.spotMap);
    },
    setSpotMapEntry: function (state, payload) {
      if (state.spotMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.spotMap = Object.assign({}, state.spotMap, entry);
      }
    },
    deleteSpotMapEntry: function (state, payload) {
      if (state.spotMap) {
        delete state.spotMap[payload.id];
        state.spotMap = Object.assign({}, state.spotMap);
      }
    },
    setEmploymentModelMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      }
      state.employmentModelMapState = tstate;
      state.employmentModelMap = Object.assign({}, payload.employmentModelMap);

    },
    setEmploymentModelMapEntry: function (state, payload) {
      if (state.employmentModelMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employmentModelMap = Object.assign({}, state.employmentModelMap, entry);
      }
    },
    deleteEmploymentModelMapEntry: function (state, payload) {
      if (state.employmentModelMap) {
        delete state.employmentModelMap[payload.id];
        state.employmentModelMap = Object.assign({}, state.employmentModelMap);
      }
    },
    setEmployeeEmploymentModelMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      }
      state.employeeEmploymentModelMapState = tstate;
      state.employeeEmploymentModelMap = Object.assign({}, payload.employeeEmploymentModelMap);

    },
    setEmployeeEmploymentModelMapEntry: function (state, payload) {
      if (state.employeeEmploymentModelMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeEmploymentModelMap = Object.assign({}, state.employeeEmploymentModelMap, entry);
      }
    },
    deleteEmployeeEmploymentModelMapEntry: function (state, payload) {
      if (state.employeeEmploymentModelMap) {
        delete state.employeeEmploymentModelMap[payload.id];
        state.employeeEmploymentModelMap = Object.assign({}, state.employeeEmploymentModelMap);
      }
    },
    setEmployeeMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),
        type: payload.type,
      }
      state.employeeMapState = tstate;
      state.employeeMap = Object.assign({}, payload.employeeMap);

    },
    setEmployeeMapEntry: function (state, payload) {
      if (state.employeeMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeMap = Object.assign({}, state.employeeMap, entry);
      }
    },
    deleteEmployeeMapEntry: function (state, payload) {
      if (state.employeeMap) {
        delete state.employeeMap[payload.id];
        state.employeeMap = Object.assign({}, state.employeeMap);
      }
    },
    setEmployeeMissingExternalIdMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      }
      state.employeeMissingExternalIdMapState = tstate;
      state.employeeMissingExternalIdMap = Object.assign({}, payload.employeeMissingExternalIdMap);

    },
    setEmployeeMissingExternalIdMapEntry: function (state, payload) {
      if (state.employeeMissingExternalIdMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeMissingExternalIdMap = Object.assign({}, state.employeeMissingExternalIdMap, entry);
      }
    },
    deleteEmployeeMissingExternalIdMapEntry: function (state, payload) {
      if (state.employeeMissingExternalIdMap) {
        delete state.employeeMissingExternalIdMap[payload.id];
        state.employeeMissingExternalIdMap = Object.assign({}, state.employeeMissingExternalIdMap);
      }
    },
    setEmployeeTypeMap: function (state, payload) {

      let tstate = {
        storeId: state.storeId,
        /* rosterFromToKey: getRosterFromToKey(state), */
      }
      state.employeeTypeMapState = tstate;
      state.employeeTypeMap = Object.assign({}, payload.employeeTypeMap);

    },
    setEmployeeTypeMapEntry: function (state, payload) {
      if (state.employeeTypeMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeTypeMap = Object.assign({}, state.employeeTypeMap, entry);
      }
    },
    deleteEmployeeTypeMapEntry: function (state, payload) {
      if (state.employeeTypeMap) {
        delete state.employeeTypeMap[payload.id];
        state.employeeTypeMap = Object.assign({}, state.employeeTypeMap);
      }
    },
    setEmployeeFilesMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.employeeFilesMapState = tstate;
      state.employeeFilesMap = Object.assign({}, payload.employeeFilesMap);
    },
    setEmployeeFilesMapEntry: function (state, payload) {
      if (state.employeeFilesMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeFilesMap = Object.assign({}, state.employeeFilesMap, entry);
      }
    },
    deleteEmployeeFilesMapEntry: function (state, payload) {
      if (state.employeeFilesMap) {
        delete state.employeeFilesMap[payload.id];
        state.employeeFilesMap = Object.assign({}, state.employeeFilesMap);
      }
    },
    setEmployeeWeeklyParametersMap: function (state, payload) {

      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),
      }
      state.employeeWeeklyParametersMapState = tstate;
      state.employeeWeeklyParametersMap = Object.assign({}, payload.employeeWeeklyParametersMap);
    },
    setEmployeeWeeklyParametersMapEntry: function (state, payload) {
      if (state.employeeWeeklyParametersMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeWeeklyParametersMap = Object.assign({}, state.employeeWeeklyParametersMap, entry);
      }
    },
    deleteEmployeeWeeklyParametersMapEntry: function (state, payload) {
      if (state.employeeWeeklyParametersMap) {
        delete state.employeeWeeklyParametersMap[payload.id];
        state.employeeWeeklyParametersMap = Object.assign({}, state.employeeWeeklyParametersMap);
      }
    },
    setEmployeeTypeTemplateMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),
      }
      state.employeeTypeTemplateMapState = tstate;
      state.employeeTypeTemplateMap = Object.assign({}, payload.employeeTypeTemplateMap);
    },
    setEmployeeTypeTemplateMapEntry: function (state, payload) {
      if (state.employeeTypeTemplateMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeTypeTemplateMap = Object.assign({}, state.employeeTypeTemplateMap, entry);
      }
    },
    deleteEmployeeTypeTemplateMapEntry: function (state, payload) {
      if (state.employeeTypeTemplateMap) {
        delete state.employeeTypeTemplateMap[payload.id];
        state.employeeTypeTemplateMap = Object.assign({}, state.employeeTypeTemplateMap);
      }
    },
    setActualShiftMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }
      state.actualShiftMapState = tstate;
      state.actualShiftMap = Object.assign({}, payload.actualShiftMap);
    },
    setActualShiftMapEntry: function (state, payload) {
      if (state.actualShiftMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.actualShiftMap = Object.assign({}, state.actualShiftMap, entry);
      }
    },
    deleteActualShiftMapEntry: function (state, payload) {
      if (state.actualShiftMap) {
        delete state.actualShiftMap[payload.id];
        state.actualShiftMap = Object.assign({}, state.actualShiftMap);
      }
    },
    setActualBreakMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }
      state.actualBreakMapState = tstate;
      state.actualBreakMap = Object.assign({}, payload.actualBreakMap);
    },
    setActualBreakMapEntry: function (state, payload) {
      if (state.actualBreakMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.actualBreakMap = Object.assign({}, state.actualBreakMap, entry);
      }
    },
    deleteActualBreakMapEntry: function (state, payload) {
      if (state.actualBreakMap) {
        delete state.actualBreakMap[payload.id];
        state.actualBreakMap = Object.assign({}, state.actualBreakMap);
      }
    },
    setActualShiftMax: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      }
      state.actualShiftMaxState = tstate;
      state.actualShiftMax = payload.actualShiftMax;
    },
    setPlanShiftMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }
      state.planShiftMapState = tstate;
      state.planShiftMap = Object.assign({}, payload.planShiftMap);
    },
    setPlanShiftMapEntry: function (state, payload) {
      if (state.planShiftMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.planShiftMap = Object.assign({}, state.planShiftMap, entry);
      }
    },
    deletePlanShiftMapEntry: function (state, payload) {
      if (state.planShiftMap) {
        delete state.planShiftMap[payload.id];
        state.planShiftMap = Object.assign({}, state.planShiftMap);
      }
    },
    setExternalShiftMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }
      state.externalShiftMapState = tstate;
      state.externalShiftMap = Object.assign({}, payload.externalShiftMap);
    },
    setExternalShiftMapEntry: function (state, payload) {
      if (state.externalShiftMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.externalShiftMap = Object.assign({}, state.externalShiftMap, entry);
      }
    },
    deleteExternalShiftMapEntry: function (state, payload) {
      if (state.externalShiftMap) {
        delete state.externalShiftMap[payload.id];
        state.externalShiftMap = Object.assign({}, state.externalShiftMap);
      }
    },
    setShiftTimeByDayMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }
      state.shiftTimeByDayMapState = tstate;
      state.shiftTimeByDayMap = Object.assign({}, payload.shiftTimeByDayMap);
    },
    setShiftTimeByHourMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }
      state.shiftTimeByHourMapState = tstate;
      state.shiftTimeByHourMap = Object.assign({}, payload.shiftTimeByHourMap);
    },
    setShiftTemplateMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        groupId: payload.groupId,
        rosterFromToKey: getRosterFromToKey(state),

      }
      state.shiftTemplateMapState = tstate;
      state.shiftTemplateMap = Object.assign({}, payload.shiftTemplateMap);
    },
    setShiftTemplateMapEntry: function (state, payload) {
      if (state.shiftTemplateMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.shiftTemplateMap = Object.assign({}, state.shiftTemplateMap, entry);
      }
    },
    deleteShiftTemplateMapEntry: function (state, payload) {
      if (state.shiftTemplateMap) {
        delete state.shiftTemplateMap[payload.id];
        state.shiftTemplateMap = Object.assign({}, state.shiftTemplateMap);
      }
    },
    setShiftTemplateGroupMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,

      }
      state.shiftTemplateGroupMapState = tstate;
      state.shiftTemplateGroupMap = Object.assign({}, payload.shiftTemplateGroupMap);
    },
    setShiftTemplateGroupMapEntry: function (state, payload) {
      if (state.shiftTemplateGroupMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.shiftTemplateGroupMap = Object.assign({}, state.shiftTemplateGroupMap, entry);
      }
    },
    deleteShiftTemplateGroupMapEntry: function (state, payload) {
      if (state.shiftTemplateGroupMap) {
        delete state.shiftTemplateGroupMap[payload.id];
        state.shiftTemplateGroupMap = Object.assign({}, state.shiftTemplateGroupMap);
      }
    },
    setShiftTemplateGroupFrameMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        year: payload.year
      }
      state.shiftTemplateGroupFrameMapState = tstate;
      state.shiftTemplateGroupFrameMap = Object.assign({}, payload.shiftTemplateGroupFrameMap);
    },
    setShiftTemplateGroupFrameMapEntry: function (state, payload) {
      if (state.shiftTemplateGroupFrameMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.shiftTemplateGroupFrameMap = Object.assign({}, state.shiftTemplateGroupFrameMap, entry);
      }
    },
    deleteShiftTemplateGroupFrameMapEntry: function (state, payload) {
      if (state.shiftTemplateGroupFrameMap) {
        delete state.shiftTemplateGroupFrameMap[payload.id];
        state.shiftTemplateGroupFrameMap = Object.assign({}, state.shiftTemplateGroupFrameMap);
      }
    },
    setEmployeeRulesTemplateMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      }
      state.employeeRulesTemplateMapState = tstate;
      state.employeeRulesTemplateMap = Object.assign({}, payload.employeeRulesTemplateMap);
    },
    setEmployeeRulesTemplateMapEntry: function (state, payload) {
      if (state.employeeRulesMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeRulesTemplateMap = Object.assign({}, state.employeeRulesTemplateMap, entry);
      }
    },
    deleteEmployeeRulesTemplateMapEntry: function (state, payload) {
      if (state.employeeRulesTemplateMap) {
        delete state.employeeRulesTemplateMap[payload.id];
        state.employeeRulesTemplateMap = Object.assign({}, state.employeeRulesTemplateMap);
      }
    },
    setEmployeeRulesMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      }
      state.employeeRulesMapState = tstate;
      state.employeeRulesMap = Object.assign({}, payload.employeeRulesMap);
    },
    setEmployeeRulesMapEntry: function (state, payload) {
      if (state.employeeRulesMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeRulesMap = Object.assign({}, state.employeeRulesMap, entry);
      }
    },
    deleteEmployeeRulesMapEntry: function (state, payload) {
      if (state.employeeRulesMap) {
        delete state.employeeRulesMap[payload.id];
        state.employeeRulesMap = Object.assign({}, state.employeeRulesMap);
      }
    },
    setCollectiveContractMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.collectiveContractMapState = tstate;
      state.collectiveContractMap = Object.assign({}, payload.collectiveContractMap);
    },
    setCollectiveContractMapEntry: function (state, payload) {
      if (state.collectiveContractMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.collectiveContractMap = Object.assign({}, state.collectiveContractMap, entry);
      }
    },
    deleteCollectiveContractMapEntry: function (state, payload) {
      if (state.collectiveContractMap) {
        delete state.collectiveContractMap[payload.id];
        state.collectiveContractMap = Object.assign({}, state.collectiveContractMap);
      }
    },
    setMlCollectiveAgreementMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.mlCollectiveAgreementMapState = tstate;
      state.mlCollectiveAgreementMap = Object.assign({}, payload.mlCollectiveAgreementMap);
    },
    setMlCollectiveAgreementMapEntry: function (state, payload) {
      if (state.mlCollectiveAgreementMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.mlCollectiveAgreementMap = Object.assign({}, state.mlCollectiveAgreementMap, entry);
      }
    },
    deleteMlCollectiveAgreementMapEntry: function (state, payload) {
      if (state.mlCollectiveAgreementMap) {
        delete state.mlCollectiveAgreementMap[payload.id];
        state.mlCollectiveAgreementMap = Object.assign({}, state.mlCollectiveAgreementMap);
      }
    },
    setMlCostCenterMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.mlCostCenterMapState = tstate;
      state.mlCostCenterMap = Object.assign({}, payload.mlCostCenterMap);
    },
    setMlCostCenterMapEntry: function (state, payload) {
      if (state.mlCostCenterMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.mlCostCenterMap = Object.assign({}, state.mlCostCenterMap, entry);
      }
    },
    deleteMlCostCenterMapEntry: function (state, payload) {
      if (state.mlCostCenterMap) {
        delete state.mlCostCenterMap[payload.id];
        state.mlCostCenterMap = Object.assign({}, state.mlCostCenterMap);
      }
    },
    setYouthWorkConfigMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.youthWorkConfigMapState = tstate;
      state.youthWorkConfigMap = Object.assign({}, payload.youthWorkConfigMap);
    },
    setYouthWorkConfigMapEntry: function (state, payload) {
      if (state.youthWorkConfigMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.youthWorkConfigMap = Object.assign({}, state.youthWorkConfigMap, entry);
      }
    },
    deleteYouthWorkConfigMapEntry: function (state, payload) {
      if (state.youthWorkConfigMap) {
        delete state.youthWorkConfigMap[payload.id];
        state.youthWorkConfigMap = Object.assign({}, state.youthWorkConfigMap);
      }
    },
    setAllowedContractMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.allowedContractMapState = tstate;
      state.allowedContractMap = Object.assign({}, payload.allowedContractMap);
    },
    setAllowedContractMapEntry: function (state, payload) {
      if (state.allowedContractMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.allowedContractMap = Object.assign({}, state.allowedContractMap, entry);
      }
    },
    deleteAllowedContractMapEntry: function (state, payload) {
      if (state.allowedContractMap) {
        delete state.allowedContractMap[payload.id];
        state.allowedContractMap = Object.assign({}, state.allowedContractMap);
      }
    },
    setAccountingPeriodSettingsMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.accountingPeriodSettingsMapState = tstate;
      state.accountingPeriodSettingsMap = Object.assign({}, payload.accountingPeriodSettingsMap);
    },
    setAccountingPeriodSettingsMapEntry: function (state, payload) {
      if (state.accountingPeriodSettingsMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.accountingPeriodSettingsMap = Object.assign({}, state.accountingPeriodSettingsMap, entry);
      }
    },
    deleteAccountingPeriodSettingsMapEntry: function (state, payload) {
      if (state.accountingPeriodSettingsMap) {
        delete state.accountingPeriodSettingsMap[payload.id];
        state.accountingPeriodSettingsMap = Object.assign({}, state.accountingPeriodSettingsMap);
      }
    },
    setContractExitSettingMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.contractExitSettingMapState = tstate;
      state.contractExitSettingMap = Object.assign({}, payload.contractExitSettingMap);
    },
    setContractExitSettingMapEntry: function (state, payload) {
      if (state.contractExitSettingMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.contractExitSettingMap = Object.assign({}, state.contractExitSettingMap, entry);
      }
    },
    deleteContractExitSettingMapEntry: function (state, payload) {
      if (state.contractExitSettingMap) {
        delete state.contractExitSettingMap[payload.id];
        state.contractExitSettingMap = Object.assign({}, state.contractExitSettingMap);
      }
    },
    setBonusPaymentSettingsMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),
      };
      state.bonusPaymentSettingsMapState = tstate;
      state.bonusPaymentSettingsMap = Object.assign({}, payload.bonusPaymentSettingsMap);
    },
    setBonusPaymentSettingsMapEntry: function (state, payload) {
      if (state.bonusPaymentSettingsMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.bonusPaymentSettingsMap = Object.assign({}, state.bonusPaymentSettingsMap, entry);
      }
    },
    deleteBonusPaymentSettingsMapEntry: function (state, payload) {
      if (state.bonusPaymentSettingsMap) {
        delete state.bonusPaymentSettingsMap[payload.id];
        state.bonusPaymentSettingsMap = Object.assign({}, state.bonusPaymentSettingsMap);
      }
    },
    setShiftSkillMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.shiftSkillMapState = tstate;
      state.shiftSkillMap = Object.assign({}, payload.shiftSkillMap);
    },
    setEmployeeContractMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.employeeContractMapState = tstate;
      state.employeeContractMap = Object.assign({}, payload.employeeContractMap);
    },
    setEmployeeContractMapEntry: function (state, payload) {
      if (state.employeeContractMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeContractMap = Object.assign({}, state.employeeContractMap, entry);
      }
    },
    deleteEmployeeContractMapEntry: function (state, payload) {
      if (state.employeeContractMap) {
        delete state.employeeContractMap[payload.id];
        state.employeeContractMap = Object.assign({}, state.employeeContractMap);
      }
    },
    setCurrentMonthEmployeeContractMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state)
      };
      state.currentMonthEmployeeContractMapState = tstate;
      state.currentMonthEmployeeContractMap = Object.assign({}, payload.currentMonthEmployeeContractMap);
    },
    setCurrentMonthEmployeeContractMapEntry: function (state, payload) {
      if (state.currentMonthEmployeeContractMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.currentMonthEmployeeContractMap = Object.assign({}, state.currentMonthEmployeeContractMap, entry);
      }
    },
    deleteCurrentMonthEmployeeContractMapEntry: function (state, payload) {
      if (state.currentMonthEmployeeContractMap) {
        delete state.currentMonthEmployeeContractMap[payload.id];
        state.currentMonthEmployeeContractMap = Object.assign({}, state.currentMonthEmployeeContractMap);
      }
    },
    setEmployeeExtraPaymentMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state)
      };
      state.employeeExtraPaymentMapState = tstate;
      state.employeeExtraPaymentMap = Object.assign({}, payload.employeeExtraPaymentMap);
    },
    setEmployeeExtraPaymentMapEntry: function (state, payload) {
      if (state.employeeExtraPaymentMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeExtraPaymentMap = Object.assign({}, state.employeeExtraPaymentMap, entry);
      }
    },
    deleteEmployeeExtraPaymentMapEntry: function (state, payload) {
      if (state.employeeExtraPaymentMap) {
        delete state.employeeExtraPaymentMap[payload.id];
        state.employeeExtraPaymentMap = Object.assign({}, state.employeeExtraPaymentMap);
      }
    },
    setRosterNoticeMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state)
      };
      state.rosterNoticeMapState = tstate;
      state.rosterNoticeMap = Object.assign({}, payload.rosterNoticeMap);
    },
    setRosterNoticeMapEntry: function (state, payload) {
      if (state.rosterNoticeMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.rosterNoticeMap = Object.assign({}, state.rosterNoticeMap, entry);
      }
    },
    deleteRosterNoticeMapEntry: function (state, payload) {
      if (state.rosterNoticeMap) {
        delete state.rosterNoticeMap[payload.id];
        state.rosterNoticeMap = Object.assign({}, state.rosterNoticeMap);
      }
    },
    setPositioningTaskMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.positioningTaskMapState = tstate;
      state.positioningTaskMap = Object.assign({}, payload.positioningTaskMap);
    },
    setPositioningTaskMapEntry: function (state, payload) {
      if (state.positioningTaskMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.positioningTaskMap = Object.assign({}, state.positioningTaskMap, entry);
      }
    },
    deletePositioningTaskMapEntry: function (state, payload) {
      if (state.positioningTaskMap) {
        delete state.positioningTaskMap[payload.id];
        state.positioningTaskMap = Object.assign({}, state.positioningTaskMap);
      }
    },
    setPositioningTaskAssignmentMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.positioningTaskAssignmentMapState = tstate;
      state.positioningTaskAssignmentMap = Object.assign({}, payload.positioningTaskAssignmentMap);
    },
    setPositioningTaskAssignmentMapEntry: function (state, payload) {
      if (state.positioningTaskAssignmentMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.positioningTaskAssignmentMap = Object.assign({}, state.positioningTaskAssignmentMap, entry);
      }
    },
    deletePositioningTaskAssignmentMapEntry: function (state, payload) {
      if (state.positioningTaskAssignmentMap) {
        delete state.positioningTaskAssignmentMap[payload.id];
        state.positioningTaskAssignmentMap = Object.assign({}, state.positioningTaskAssignmentMap);
      }
    },
    setPositioningEntryMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.positioningEntryMapState = tstate;
      state.positioningEntryMap = Object.assign({}, payload.positioningEntryMap);
    },
    setPositioningEntryMapEntry: function (state, payload) {
      if (state.positioningEntryMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.positioningEntryMap = Object.assign({}, state.positioningEntryMap, entry);
      }
    },
    deletePositioningEntryMapEntry: function (state, payload) {
      if (state.positioningEntryap) {
        delete state.positioningEntryMap[payload.id];
        state.positioningEntryMap = Object.assign({}, state.positioningEntryMap);
      }
    },
    setEmployeePreferenceMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),
        type: payload.type,
      };
      state.employeePreferenceMapState = tstate;
      state.employeePreferenceMap = Object.assign({}, payload.employeePreferenceMap);
    },
    setEmployeeAllUnapprovedPreferenceMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.employeeAllUnapprovedPreferenceMapState = tstate;
      state.employeeAllUnapprovedPreferenceMap = Object.assign({}, payload.employeeAllUnapprovedPreferenceMap);
    },
    setEmployeeAllUnapprovedPreferenceMapEntry: function (state, payload) {
      if (state.employeeAllUnapprovedPreferenceMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeAllUnapprovedPreferenceMap = Object.assign({}, state.employeeAllUnapprovedPreferenceMap, entry);
      }
    },
    deleteEmployeeAllUnapprovedPreferenceMapEntry: function (state, payload) {
      if (state.employeeAllUnapprovedPreferenceMap) {
        if (state.employeeAllUnapprovedPreferenceMap[payload.id]) {
          delete state.employeeAllUnapprovedPreferenceMap[payload.id];
          state.employeeAllUnapprovedPreferenceMap = Object.assign({}, state.employeeAllUnapprovedPreferenceMap);
        }
      }
    },
    setEmployeePreferenceMapEntry: function (state, payload) {
      if (state.employeePreferenceMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeePreferenceMap = Object.assign({}, state.employeePreferenceMap, entry);
      }
    },
    deleteEmployeePreferenceMapEntry: function (state, payload) {
      if (state.employeePreferenceMap) {
        delete state.employeePreferenceMap[payload.id];
        state.employeePreferenceMap = Object.assign({}, state.employeePreferenceMap);
      }
    },
    setEmployeeWorkbalanceMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),
        type: payload.type,
      };
      state.employeeWorkbalanceMapState = tstate;
      state.employeeWorkbalanceMap = Object.assign({}, payload.employeeWorkbalanceMap);
    },
    setEmployeeWorkbalanceMapEntry: function (state, payload) {
      if (state.employeeWorkbalanceMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeWorkbalanceMap = Object.assign({}, state.employeeWorkbalanceMap, entry);
      }
    },
    setEmployeeSkillMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        type: payload.type,
        rosterFromToKey: getRosterFromToKey(state),
      };
      state.employeeSkillMapState = tstate;
      state.employeeSkillMap = Object.assign({}, payload.employeeSkillMap);
    },
    setEmployeeSkillMapEntry: function (state, payload) {
      if (state.employeeSkillMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeSkillMap = Object.assign({}, state.employeeSkillMap, entry);
      }
    },
    deleteEmployeeSkillMapEntry: function (state, payload) {
      if (state.employeeSkillMap) {
        delete state.employeeSkillMap[payload.id];
        state.employeeSkillMap = Object.assign({}, state.employeeSkillMap);
      }
    },
    setEmployeeAvailabilityMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        type: payload.type,
      };
      state.employeeAvailabilityMapState = tstate;
      state.employeeAvailabilityMap = Object.assign({}, payload.employeeAvailabilityMap);
    },
    setEmployeeAvailabilityMapEntry: function (state, payload) {
      if (state.employeeAvailabilityMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeAvailabilityMap = Object.assign({}, state.employeeAvailabilityMap, entry);
      }
    },
    deleteEmployeeAvailabilityMapEntry: function (state, payload) {
      if (state.employeeAvailabilityMap) {
        delete state.employeeAvailabilityMap[payload.id];
        state.employeeAvailabilityMap = Object.assign({}, state.employeeAvailabilityMap);
      }
    },
    setEventLogMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        timestamp: new Date().getTime,
        validity: payload.validity ? payload.validity : 60000
      };
      state.eventLogMapState = tstate;
      state.eventLogMap = Object.assign({}, payload.eventLogMap);
    },
    setUserUnitSortMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      }
      state.userUnitSortMapState = tstate;
      state.userUnitSortMap = Object.assign({}, payload.userUnitSortMap);
    },
    setUiDataMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      }
      state.uiDataMapState = tstate;
      state.uiDataMap = Object.assign({}, payload.uiDataMap);
    },
    setHolidayMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        year: payload.year
      }
      state.holidayMapState = tstate;
      state.holidayMap = Object.assign({}, payload.holidayMap);
    },
    setEmployeeExternalDataMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.employeeExternalDataMapState = tstate;
      state.employeeExternalDataMap = Object.assign({}, payload.employeeExternalDataMap);
    },
    setExternalServicesMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.externalServicesMapState = tstate;
      state.externalServicesMap = Object.assign({}, payload.externalServicesMap);
    },
    setProjectGroupMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.projectGroupMapState = tstate;
      state.projectGroupMap = Object.assign({}, payload.projectGroupMap);
    },
    setProjectGroupMapEntry: function (state, payload) {
      if (state.projectGroupMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.projectGroupMap = Object.assign({}, state.projectGroupMap, entry);
      }
    },
    deleteProjectGroupMapEntry: function (state, payload) {
      if (state.projectGroupMap) {
        delete state.projectGroupMap[payload.id];
        state.projectGroupMap = Object.assign({}, state.projectGroupMap);
      }
    },
    setProjectMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        year: payload.year
      };
      state.projectMapState = tstate;
      state.projectMap = Object.assign({}, payload.projectMap);
    },
    setProjectMapEntry: function (state, payload) {
      if (state.projectMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.projectMap = Object.assign({}, state.projectMap, entry);
      }
    },
    deleteProjectMapEntry: function (state, payload) {
      if (state.projectMap) {
        delete state.projectMap[payload.id];
        state.projectMap = Object.assign({}, state.projectMap);
      }
    },
    setLocationMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.locationMapState = tstate;
      state.locationMap = Object.assign({}, payload.locationMap);
    },
    setLocationMapEntry: function (state, payload) {
      if (state.locationMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.locationMap = Object.assign({}, state.locationMap, entry);
      }
    },
    deleteLocationMapEntry: function (state, payload) {
      if (state.locationMap) {
        delete state.locationMap[payload.id];
        state.locationMap = Object.assign({}, state.locationMap);
      }
    },
    setExportSettingsMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.exportSettingsMapState = tstate;
      state.exportSettingsMap = Object.assign({}, payload.exportSettingsMap);
    },
    setExportSettingsMapEntry: function (state, payload) {
      if (state.exportSettingsMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.exportSettingsMap = Object.assign({}, state.exportSettingsMap, entry);
      }
    },
    deleteExportSettingsMapEntry: function (state, payload) {
      if (state.exportSettingsMap) {
        delete state.exportSettingsMap[payload.id];
        state.exportSettingsMap = Object.assign({}, state.exportSettingsMap);
      }
    },
    setCrewlaborPlanningMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        groupId: payload.groupId,
        year: payload.year
      };
      state.crewlaborPlanningMapState = tstate;
      state.crewlaborPlanningMap = Object.assign({}, payload.crewlaborPlanningMap);

    },
    setCrewlaborPlanningMapEntry: function (state, payload) {
      if (state.crewlaborPlanningMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.crewlaborPlanningMap = Object.assign({}, state.crewlaborPlanningMap, entry);
      }
    },
    setPlanningEmployeeMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        groupId: payload.groupId,
        year: payload.year
      };
      state.planningEmployeeMapState = tstate;
      state.planningEmployeeMap = Object.assign({}, payload.planningEmployeeMap);

    },
    setPlanningEmployeeMapEntry: function (state, payload) {
      if (state.planningEmployeeMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.planningEmployeeMap = Object.assign({}, state.planningEmployeeMap, entry);
      }
    },
    deletePlanningEmployeeMapEntry: function (state, payload) {
      if (state.planningEmployeeMap) {
        delete state.planningEmployeeMap[payload.id];
        state.planningEmployeeMap = Object.assign({}, state.planningEmployeeMap);
      }
    },
    setPlanningEmployeeThresholdMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.planningEmployeeThresholdMapState = tstate;
      state.planningEmployeeThresholdMap = Object.assign({}, payload.planningEmployeeThresholdMap);

    },
    setPlanningEmployeeThresholdMapEntry: function (state, payload) {
      if (state.planningEmployeeThresholdMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.planningEmployeeThresholdMap = Object.assign({}, state.planningEmployeeThresholdMap, entry);
      }
    },
    deletePlanningEmployeeThresholdMapEntry: function (state, payload) {
      if (state.planningEmployeeThresholdMap) {
        delete state.planningEmployeeThresholdMap[payload.id];
        state.planningEmployeeThresholdMap = Object.assign({}, state.planningEmployeeThresholdMap);
      }
    },
    setContactPersonMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.contactPersonMapState = tstate;
      state.contactPersonMap = Object.assign({}, payload.contactPersonMap);

    },
    setContactPersonMapEntry: function (state, payload) {
      if (state.contactPersonMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.contactPersonMap = Object.assign({}, state.contactPersonMap, entry);
      }
    },
    deleteContactPersonMapEntry: function (state, payload) {
      if (state.contactPersonMap) {
        delete state.contactPersonMap[payload.id];
        state.contactPersonMap = Object.assign({}, state.contactPersonMap);
      }
    },
    setEmailNotificationMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.emailNotificationMapState = tstate;
      state.emailNotificationMap = Object.assign({}, payload.emailNotificationMap);

    },
    setEmailNotificationMapEntry: function (state, payload) {
      if (state.emailNotificationMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.emailNotificationMap = Object.assign({}, state.emailNotificationMap, entry);
      }
    },
    deleteEmailNotificationMapEntry: function (state, payload) {
      if (state.emailNotificationMap) {
        delete state.emailNotificationMap[payload.id];
        state.emailNotificationMap = Object.assign({}, state.emailNotificationMap);
      }
    },
    setMlEmailNotificationMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.mlEmailNotificationMapState = tstate;
      state.mlEmailNotificationMap = Object.assign({}, payload.mlEmailNotificationMap);

    },
    setMlEmailNotificationMapEntry: function (state, payload) {
      if (state.mlEmailNotificationMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.mlEmailNotificationMap = Object.assign({}, state.mlEmailNotificationMap, entry);
      }
    },
    deleteMlEmailNotificationMapEntry: function (state, payload) {
      if (state.mlEmailNotificationMap) {
        delete state.mlEmailNotificationMap[payload.id];
        state.mlEmailNotificationMap = Object.assign({}, state.mlEmailNotificationMap);
      }
    },
    setApiIntegrationDataMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId
      };
      state.apiIntegrationDataMapState = tstate;
      state.apiIntegrationDataMap = Object.assign({}, payload.apiIntegrationDataMap);
    },
    setApiIntegrationDataMapEntry: function (state, payload) {
      if (state.apiIntegrationDataMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.apiIntegrationDataMap = Object.assign({}, state.apiIntegrationDataMap, entry);
      }
    },
    deleteApiIntegrationDataMapEntry: function (state, payload) {
      if (state.apiIntegrationDataMap) {
        delete state.apiIntegrationDataMap[payload.id];
        state.apiIntegrationDataMap = Object.assign({}, state.apiIntegrationDataMap);
      }
    },
    setExternalApiAccessMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.externalApiAccessMapState = tstate;
      state.externalApiAccessMap = Object.assign({}, payload.externalApiAccessMap);

    },
    setExternalApiAccessMapEntry: function (state, payload) {
      if (state.externalApiAccessMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.externalApiAccessMap = Object.assign({}, state.externalApiAccessMap, entry);
      }
    },
    deleteExternalApiAccessMapEntry: function (state, payload) {
      if (state.externalApiAccessMap) {
        delete state.externalApiAccessMap[payload.id];
        state.externalApiAccessMap = Object.assign({}, state.externalApiAccessMap);
      }
    },

    setOpeningHoursMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.storeOpeningHoursMapState = tstate;
      state.storeOpeningHoursMap = Object.assign({}, payload.storeOpeningHoursMap);

    },
    setOpeningHoursMapEntry: function (state, payload) {
      if (state.storeOpeningHoursMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.storeOpeningHoursMap = Object.assign({}, state.storeOpeningHoursMap, entry);
      }
    },
    deleteOpeningHoursMapEntry: function (state, payload) {
      if (state.storeOpeningHoursMap) {
        delete state.storeOpeningHoursMap[payload.id];
        state.storeOpeningHoursMap = Object.assign({}, state.storeOpeningHoursMap);
      }
    },
    setShiftStatusLogMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.shiftStatusLogMapState = tstate;
      state.shiftStatusLogMap = Object.assign({}, payload.shiftStatusLogMap);

    },
    setShiftStatusLogMapEntry: function (state, payload) {
      if (state.shiftStatusLogMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.shiftStatusLogMap = Object.assign({}, state.shiftStatusLogMap, entry);
      }
    },
    deleteShiftStatusLogMapEntry: function (state, payload) {
      if (state.shiftStatusLogMap) {
        delete state.shiftStatusLogMap[payload.id];
        state.shiftStatusLogMap = Object.assign({}, state.shiftStatusLogMap);
      }
    },
    setVlhTimeFrameMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.vlhTimeFrameMapState = tstate;
      state.vlhTimeFrameMap = Object.assign({}, payload.vlhTimeFrameMap);

    },
    setVlhTimeFrameMapEntry: function (state, payload) {
      if (state.vlhTimeFrameMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.vlhTimeFrameMap = Object.assign({}, state.vlhTimeFrameMap, entry);
      }
    },
    deleteVlhTimeFrameMapEntry: function (state, payload) {
      if (state.vlhTimeFrameMap) {
        delete state.vlhTimeFrameMap[payload.id];
        state.vlhTimeFrameMap = Object.assign({}, state.vlhTimeFrameMap);
      }
    },
    setVlhConversionMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.vlhConversionMapState = tstate;
      state.vlhConversionMap = Object.assign({}, payload.vlhConversionMap);

    },
    setVlhConversionMapEntry: function (state, payload) {
      if (state.vlhConversionMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.vlhConversionMap = Object.assign({}, state.vlhConversionMap, entry);
      }
    },
    deleteVlhConversionMapEntry: function (state, payload) {
      if (state.vlhConversionMap) {
        delete state.vlhConversionMap[payload.id];
        state.vlhConversionMap = Object.assign({}, state.vlhConversionMap);
      }
    },
    setVlhConfigMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.vlhConfigMapState = tstate;
      state.vlhConfigMap = Object.assign({}, payload.vlhConfigMap);

    },
    setVlhConfigMapEntry: function (state, payload) {
      if (state.vlhConfigMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.vlhConfigMap = Object.assign({}, state.vlhConfigMap, entry);
      }
    },
    deleteVlhConfigMapEntry: function (state, payload) {
      if (state.vlhConfigMap) {
        delete state.vlhConfigMap[payload.id];
        state.vlhConfigMap = Object.assign({}, state.vlhConfigMap);
      }
    },
    setVlhEmployeeThresholdMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.vlhEmployeeThresholdMapState = tstate;
      state.vlhEmployeeThresholdMap = Object.assign({}, payload.vlhEmployeeThresholdMap);

    },
    setVlhEmployeeThresholdMapEntry: function (state, payload) {
      if (state.vlhEmployeeThresholdMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.vlhEmployeeThresholdMap = Object.assign({}, state.vlhEmployeeThresholdMap, entry);
      }
    },
    deleteVlhEmployeeThresholdMapEntry: function (state, payload) {
      if (state.vlhEmployeeThresholdMap) {
        delete state.vlhEmployeeThresholdMap[payload.id];
        state.vlhEmployeeThresholdMap = Object.assign({}, state.vlhEmployeeThresholdMap);
      }
    },
    setPlanningIndicatorTypeMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
      };
      state.planningIndicatorTypeMapState = tstate;
      state.planningIndicatorTypeMap = Object.assign({}, payload.planningIndicatorTypeMap);

    },
    setPlanningIndicatorTypeMapEntry: function (state, payload) {
      if (state.planningIndicatorTypeMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.planningIndicatorTypeMap = Object.assign({}, state.planningIndicatorTypeMap, entry);
      }
    },
    deletePlanningIndicatorTypeMapEntry: function (state, payload) {
      if (state.planningIndicatorTypeMap) {
        delete state.planningIndicatorTypeMap[payload.id];
        state.planningIndicatorTypeMap = Object.assign({}, state.planningIndicatorTypeMap);
      }
    },
    setRosterBackupMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }

      state.rosterBackupMapState = tstate;
      state.rosterBackupMap = Object.assign({}, payload.rosterBackupMap);
    },
    setRosterBackupMapEntry: function (state, payload) {
      if (state.rosterBackupMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.rosterBackupMap = Object.assign({}, state.rosterBackupMap, entry);
      }
    },
    deleteRosterBackupMapEntry: function (state, payload) {
      if (state.rosterBackupMap) {
        delete state.rosterBackupMap[payload.id];
        state.rosterBackupMap = Object.assign({}, state.rosterBackupMap);
      }
    },
    setEmployeeAvgWorktimeMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),
      };
      state.employeeAvgWorktimeMapState = tstate;
      state.employeeAvgWorktimeMap = Object.assign({}, payload.employeeAvgWorktimeMap);

    },
    setEmployeeAvgWorktimeMapEntry: function (state, payload) {
      if (state.employeeAvgWorktimeMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.employeeAvgWorktimeMap = Object.assign({}, state.employeeAvgWorktimeMap, entry);
      }
    },
    deleteEmployeeAvgWorktimeMapEntry: function (state, payload) {
      if (state.employeeAvgWorktimeMap) {
        delete state.employeeAvgWorktimeMap[payload.id];
        state.employeeAvgWorktimeMap = Object.assign({}, state.employeeAvgWorktimeMap);
      }
    },
    setFixedCostMap: function (state, payload) {
      let tstate = {
        storeId: state.storeId,
        rosterFromToKey: getRosterFromToKey(state),

      }
      state.fixedCostMapState = tstate;
      state.fixedCostMap = Object.assign({}, payload.fixedCostMap);

    },
    setFixedCostMapEntry: function (state, payload) {
      if (state.fixedCostMap) {
        let entry = {};
        entry[payload.id] = payload;
        state.fixedCostMap = Object.assign({}, state.fixedCostMap, entry);
      }
    },
    deleteFixedCostMapEntry: function (state, payload) {
      if (state.fixedCostMap) {
        delete state.fixedCostMap[payload.id];
        state.fixedCostMap = Object.assign({}, state.fixedCostMap);
      }
    },
    deleteMultiple: function (state, payload) {
      let toRenew = [];
      payload.forEach(toDelete => {
        let mapName = toDelete.mapName;
        let id = toDelete.id;
        if (state[mapName]) {
          delete state[mapName][id];
          if (!toRenew.includes(mapName)) {
            toRenew.push(mapName);
          }
        }
      });
      toRenew.forEach(mapName => {
        state[mapName] = Object.assign({}, state[mapName]);
      });
    },
    updateMultiple: function (state, payload) {
      let toRenew = [];
      payload.forEach(toUpdate => {
        let mapName = toUpdate.mapName;
        let entity = toUpdate.entity;

        if (state[mapName]) {
          state[mapName][entity.id] = entity;
          if (!toRenew.includes(mapName)) {
            toRenew.push(mapName);
          }
        }
      });
      toRenew.forEach(mapName => {
        state[mapName] = Object.assign({}, state[mapName]);
      });

    },
    setAnonMode: function (state, payload) {
      state.anonMode = payload;
    },
    setNightMode: function (state, payload) {
      state.nightMode = payload;
    },
    setEmployeeSortState: function (state, payload) {
      state.employeeSortState = payload.employeeSortState;
      localStorage.setItem('employeeSortState', JSON.stringify(state.employeeSortState));
    },
    setEmployeeSortStateToggle: function (state, type) {
      if (!state.employeeSortState.hasOwnProperty(type)) {
        console.warn('invalid sort type: ' + type);
        return;
      }
      state.employeeSortState[type] = !state.employeeSortState[type];
      state.employeeSortState = Object.assign({}, state.employeeSortState);
      localStorage.setItem('employeeSortState', JSON.stringify(state.employeeSortState));
    },
    setRosterSortState: function (state, payload) {
      state.rosterSortState = payload.rosterSortState;
      localStorage.setItem('rosterSortState', JSON.stringify(state.rosterSortState));
    },
    setRosterSortStateToggle: function (state, type) {
      if (!state.rosterSortState.hasOwnProperty(type)) {
        console.warn('invalid sort type: ' + type);
        return;
      }
      state.rosterSortState[type] = !state.rosterSortState[type];
      state.rosterSortState = Object.assign({}, state.rosterSortState);
      localStorage.setItem('rosterSortState', JSON.stringify(state.rosterSortState));
    },
    setRosterVisibilityState: function (state, payload) {
      state.rosterVisibilityState = payload.rosterVisibilityState;
      localStorage.setItem('rosterVisibilityState', JSON.stringify(state.rosterVisibilityState));
    },
    setRosterVisibilityStateTrue: function (state, type) {
      if (!state.rosterVisibilityState.hasOwnProperty(type)) {
        console.warn('visibility key \'' + type + '\' not set in default');
        return;
      }
      state.rosterVisibilityState[type] = true;
      localStorage.setItem('rosterVisibilityState', JSON.stringify(state.rosterVisibilityState));
    },
    setRosterVisibilityStateFalse: function (state, type) {
      if (!state.rosterVisibilityState.hasOwnProperty(type)) {
        console.warn('invalid visibility type: ' + type);
        return;
      }
      state.rosterVisibilityState[type] = false;
      localStorage.setItem('rosterVisibilityState', JSON.stringify(state.rosterVisibilityState));
    },
    setRosterVisibilityStateToggle: function (state, type) {
      if (!state.rosterVisibilityState.hasOwnProperty(type)) {
        console.warn('invalid visibility type: ' + type);
        return;
      }
      state.rosterVisibilityState[type] = !state.rosterVisibilityState[type];
      localStorage.setItem('rosterVisibilityState', JSON.stringify(state.rosterVisibilityState));
    },
    setNotificationBellConfigState: function (state, payload) {
      state.notificationBellConfigState = payload.notificationBellConfigState;
      localStorage.setItem('notificationBellConfigState', JSON.stringify(state.notificationBellConfigState));
    },
    setNotificationBellConfigStateValue: function (state, payload) {
      if (payload.key == null || payload.value == null || !state.notificationBellConfigState.hasOwnProperty(payload.key)) {
        console.warn('invalid notification bell config type: ' + payload.key);
        return;
      }
      state.notificationBellConfigState[payload.key] = payload.value;
      localStorage.setItem('notificationBellConfigState', JSON.stringify(state.notificationBellConfigState));
    },
    setFtaConfigState: function (state, payload) {
      state.ftaConfigState = payload.ftaConfigState;
      localStorage.setItem('ftaConfigState', JSON.stringify(state.ftaConfigState));
    },
    setCrewLaborConfig: function(state, payload){
      let tstate = {
        storeId: state.storeId,
      }
      state.crewLaborConfigState = tstate;
      state.crewLaborConfig = payload.crewLaborConfig;

    },
    setSotecWebcockpitConfig: function(state, payload){
      let tstate = {
        storeId: state.storeId,
      }
      state.sotecWebcockpitConfigState = tstate;
      state.sotecWebcockpitConfig = payload.sotecWebcockpitConfig;
    },
    setFtaConfigStateValue: function (state, payload) {
      if (payload.key == null || payload.value == null || !state.ftaConfigState.hasOwnProperty(payload.key)) {
        console.warn('invalid fta config type: ' + payload.key);
        return;
      }
      state.ftaConfigState[payload.key] = payload.value;
      localStorage.setItem('ftaConfigState', JSON.stringify(state.ftaConfigState));
    },

    invalidateState: function (state, payload) {
      let toInvalidate = payload.states;
      toInvalidate.forEach(s => {
        if (state[s]) {
          state[s] = {};
        }
      });
    },

    setDisplayPdChart: function (state, payload) {
      state.displayPdChart = payload.displayPdChart;
      localStorage.setItem('rosterdisplayPdChart', payload.displayPdChart ? '1' : '0');
    },
    setPDCachedData: function (state, payload) {
      state.pdCachedData = {...payload.pdCachedData};
    },
    setPDDetailData: function (state, payload) {
      state.pdDetailData = payload.pdDetailData;
    },
    setPDPastDetailData: function (state, payload) {
      state.pdPastDetailData = payload.pdPastDetailData;
    },
    setPDSelectedStat: function (state, payload) {
      state.pdSelectedStat = payload.pdSelectedStat;
    },
    setPDChartAreaHeight: function (state, payload) {
      state.pdChartAreaHeight = payload.pdChartAreaHeight;
    },
  },
  actions: {
    cachePDData: function ({commit, state}, {cachingKey, data}) {
      let entry = {data, usageCount: 0};
      if (state.pdCachedData[cachingKey])
        entry.usageCount = state.pdCachedData[cachingKey].usageCount + 1;

      // LFU policy impl
      let newCachedData = {...state.pdCachedData};
      const cacheEntries = Object.entries(newCachedData);
      if (cacheEntries.length >= 40) {
        let leastFreqUsedKey = null;
        let leastFreqUsedCount = Number.MAX_VALUE;
        for (const [k, e] of cacheEntries) {
          if (e.usageCount < leastFreqUsedCount) {
            leastFreqUsedCount = e.usageCount;
            leastFreqUsedKey = k;
          }
        }
        if (leastFreqUsedKey !== null) // key being null should never be the case though
          delete newCachedData[leastFreqUsedKey];
      }

      newCachedData = {...newCachedData, [cachingKey]: entry};

      commit('setPDCachedData', {pdCachedData: newCachedData});
    },
    initConfigStates: function ({commit, state}) {
      console.log('initConfigStates')
      
        let employeeSortState = initEmployeeSortState(state);
        commit('setEmployeeSortState', {employeeSortState: employeeSortState});
        let rosterVisibilityState = initRosterVisibilityState(state);
        commit('setRosterVisibilityState', {rosterVisibilityState: rosterVisibilityState});
        let notificationBellConfigState = initNotificationBellConfigState(state);
        commit('setNotificationBellConfigState', {notificationBellConfigState: notificationBellConfigState});
        let ftaConfigState = initFtaConfigState(state);
        commit('setFtaConfigState', {ftaConfigState: ftaConfigState});

        let rosterSortState = initRosterSortState(state);
        commit('setRosterSortState', {rosterSortState: rosterSortState});
      
      

    },
  }
})


function getRosterFromToKey(state) {
  if (state.rosterFromTo && state.rosterFromTo.from && state.rosterFromTo.to) {
    return state.rosterFromTo.from + " - " + state.rosterFromTo.to;
  } else {
    return "no-key"
  }
}

function initEmployeeSortState(state) {
    let employeeSortState = localStorage.getItem('employeeSortState');
    if (!employeeSortState) {
        employeeSortState = {
          showBusinessUnits: true,
          sortByContractType: false,
          sortByPriority: true,
        };
    } else {
      try{
        employeeSortState = JSON.parse(employeeSortState);
      } catch(error) {
        console.log(error);
        employeeSortState = {
          showBusinessUnits: true,
          sortByContractType: false,
          sortByPriority: true,
        };
      }
    }
    let defaultValues = state.employeeSortState;

    let deprecatedKeys = Object.keys(employeeSortState).filter(savedKey => !Object.keys(defaultValues).find(defaultKey => defaultKey === savedKey));
    deprecatedKeys.forEach(key => delete employeeSortState[key]);

    for (let key in defaultValues) {
        if (!employeeSortState.hasOwnProperty(key)) employeeSortState[key] = defaultValues[key];
    }

    localStorage.setItem('employeeSortState', JSON.stringify(employeeSortState));
    return employeeSortState;
}

function initRosterVisibilityState(state) {
    let rosterVisibilityState = localStorage.getItem('rosterVisibilityState');
    if (!rosterVisibilityState) {
        rosterVisibilityState = {};
    } else {
      try{
        rosterVisibilityState = JSON.parse(rosterVisibilityState);
      } catch(error){
        console.log(error);
        rosterVisibilityState = {};
      }
        
    }

    if(!state.isSuperUser){
        rosterVisibilityState.visibilityProductivityNew = false;
        rosterVisibilityState.visibilityRoundProductivity = false;
    }

    let defaultValues = state.rosterVisibilityState;

    let deprecatedKeys = Object.keys(rosterVisibilityState).filter(savedKey => !Object.keys(defaultValues).find(defaultKey => defaultKey === savedKey));
    deprecatedKeys.forEach(key => delete rosterVisibilityState[key]);

    for (let key in defaultValues) {
        if (!rosterVisibilityState.hasOwnProperty(key)) rosterVisibilityState[key] = defaultValues[key];
    }

    localStorage.setItem('rosterVisibilityState', JSON.stringify(rosterVisibilityState));
    return rosterVisibilityState;
}

function initRosterSortState(state) {
    let rosterSortState = localStorage.getItem('rosterSortState');
    if (!rosterSortState) {
        rosterSortState = {};
    } else {
        try {
          rosterSortState = JSON.parse(rosterSortState);
        } catch(error){
          console.log(error)
          rosterSortState = {};
        }
        
    }
    
    let defaultValues = state.rosterSortState;

    let deprecatedKeys = Object.keys(rosterSortState).filter(savedKey => !Object.keys(defaultValues).find(defaultKey => defaultKey === savedKey));
    deprecatedKeys.forEach(key => delete rosterSortState[key]);

    for (let key in defaultValues) {
        if (!rosterSortState.hasOwnProperty(key)) rosterSortState[key] = defaultValues[key];
    }
    console.log(JSON.stringify(rosterSortState));
    localStorage.setItem('rosterSortState', JSON.stringify(rosterSortState));
    return rosterSortState;
}

function initNotificationBellConfigState(state) {

    let notificationBellConfigState = localStorage.getItem('notificationBellConfigState');
    if (!notificationBellConfigState) {
      notificationBellConfigState = {};
    } else {
      try {
        notificationBellConfigState = JSON.parse(notificationBellConfigState);
      } catch(error){
        console.log(error);
        notificationBellConfigState = {};
      }
      
    }
    let defaultValues = state.notificationBellConfigState;
    let deprecatedKeys = Object.keys(notificationBellConfigState).filter(savedKey => !Object.keys(defaultValues).find(defaultKey => defaultKey === savedKey));
    deprecatedKeys.forEach(key => delete notificationBellConfigState[key]);

    for (let key in defaultValues) {
      if (!notificationBellConfigState.hasOwnProperty(key)) notificationBellConfigState[key] = defaultValues[key];
    }
    localStorage.setItem('notificationBellConfigState', JSON.stringify(notificationBellConfigState));
    return notificationBellConfigState;
}

function initFtaConfigState(state) {
    let ftaConfigState = localStorage.getItem('ftaConfigState');
    if (!ftaConfigState) {
        ftaConfigState = {
          configSelectionTimeframe: 0,
          configCreateTimeframe: 0,
          configUseOvertime: true,
          configUseWeekOvertime: true,
          configUseCustomMax: false,
          configAllowOverPlanWorktime: false,
          configAddPositivePrevMonthWorktime: true,
          configAddNegativePrevMonthWorktime: false,
          configAllowDaysWithPastMidnight: false,
          customMaxTime: 9.0,
          additionalFTADays: 0,
          maxWorkDays: 5,
        };
    } else {
      try {
        ftaConfigState = JSON.parse(ftaConfigState);
      } catch(error){
        console.log(error);
        ftaConfigState = {
          configSelectionTimeframe: 0,
          configCreateTimeframe: 0,
          configUseOvertime: true,
          configUseWeekOvertime: true,
          configUseCustomMax: false,
          configAllowOverPlanWorktime: false,
          configAddPositivePrevMonthWorktime: true,
          configAddNegativePrevMonthWorktime: false,
          configAllowDaysWithPastMidnight: false,
          customMaxTime: 9.0,
          additionalFTADays: 0,
          maxWorkDays: 5,
        };
      }
      
    }
    let defaultValues = state.ftaConfigState;

    let deprecatedKeys = Object.keys(ftaConfigState).filter(savedKey => !Object.keys(defaultValues).find(defaultKey => defaultKey === savedKey));
    deprecatedKeys.forEach(key => delete ftaConfigState[key]);

    for (let key in defaultValues) {
      if (!ftaConfigState.hasOwnProperty(key)) ftaConfigState[key] = defaultValues[key];
    }

    localStorage.setItem('ftaConfigState', JSON.stringify(ftaConfigState));
    return ftaConfigState;
}
